import { useMutation } from '@apollo/client';
import { BaseForm } from '@bnnvara/forms/src/new_components/BaseForm/BaseForm';
import { Checkbox } from '@bnnvara/forms/src/new_components/inputs/Checkbox/Checkbox';
import { Select } from '@bnnvara/forms/src/new_components/inputs/Select/Select';
import { TextInput } from '@bnnvara/forms/src/new_components/inputs/TextInput/TextInput';
import { RadioButtonInlineGroup } from '@bnnvara/forms/src/new_components/RadioButtonInlineGroup/RadioButtonInlineGroup';
import { SubmitButton } from '@bnnvara/forms/src/new_components/SubmitButton/SubmitButton';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { useDonation } from './useDonation';
import { link } from './constants';

import { Donate } from '../../api/mutations/donate.gql';

import * as S from './styled';

const Form = ({ donateMutation }) => {
  const {
    handleNumberInput,
    setPeriod,
    handleOnSubmit,
    selectedAmountOptions,
    amount,
    setAmount,
    paymentTermOptions,
    formData,
    period,
  } = useDonation();

  return (
    <Fragment>
      <S.Wrapper>
        <S.Heading element="h2" variant="one">
          Ja, ik doneer
        </S.Heading>
        <BaseForm
          id="donate-form"
          onSubmit={(params) => handleOnSubmit(params, donateMutation)}
        >
          <S.Grid fullWidth>
            <GridItem
              columnStartSm="1"
              columnEndSm="8"
              columnStartMd="1"
              columnEndMd="7"
              columnStartLg="1"
              columnEndLg="span 5"
            >
              <Select
                showPlaceholder={false}
                value={period}
                name="paymentTerm"
                options={paymentTermOptions}
                passValueOnChange={(periodInput) => setPeriod(periodInput)}
              />
            </GridItem>
            <GridItem
              columnStartSm="1"
              columnEndSm="14"
              columnStartMd="1"
              columnStartLg="span 8"
            >
              <RadioButtonInlineGroup
                label="bedrag"
                name="amount"
                options={selectedAmountOptions}
                passValueOnChange={(value) => setAmount(value)}
              />
            </GridItem>
          </S.Grid>

          {amount === 'anders' && (
            <S.Grid fullWidth>
              <GridItem
                columnStartSm="7"
                columnStartLg="6"
                columnStartMd="7"
                columnEndSm="14"
                columnEndMd="span 7"
                columnEndLg="14"
              >
                <TextInput
                  showIsRequired
                  type="number"
                  name="amount"
                  onKeyPress={handleNumberInput}
                  label="Ander bedrag"
                  validation="required|greaterThanZero"
                  helperText="Vul een afgerond bedrag in van minimaal €1,-"
                />
              </GridItem>
            </S.Grid>
          )}

          <S.Grid fullWidth>
            <GridItem
              columnStartMd="1"
              columnEndMd="span 8"
              columnEndSm="span 7"
              columnStartSm="1"
            >
              <TextInput
                fullWidth
                showIsRequired
                type="text"
                name="firstName"
                label="Voornaam"
                placeholder=""
                validation="required|name"
                value={formData?.firstName}
              />
            </GridItem>
            <GridItem columnEndSm="span 5" columnEndMd="span 4">
              <TextInput
                fullWidth
                type="text"
                name="nameAffix"
                label="Tussenvoegsel"
                value={formData?.middleName}
              />
            </GridItem>
          </S.Grid>
          <S.Grid fullWidth>
            <GridItem
              columnStartSm="1"
              columnEndSm="14"
              columnEndMd="14"
              columnEndLg="14"
            >
              <TextInput
                fullWidth
                showIsRequired
                type="text"
                name="lastName"
                label="Achternaam"
                placeholder=""
                validation="required|name"
                value={formData?.lastName}
              />
            </GridItem>
          </S.Grid>
          <S.Grid fullWidth>
            <GridItem
              columnStartSm="1"
              columnEndSm="14"
              columnEndMd="14"
              columnEndLg="14"
            >
              <TextInput
                fullWidth
                showIsRequired
                type="text"
                name="email"
                label="E-mailadres"
                helperText="Wij sturen je per e-mail een overzicht van jouw donatie en informeren je over de status van jouw donatie."
                placeholder=""
                validation="required|email"
                value={formData?.email}
              />
            </GridItem>
          </S.Grid>
          <Checkbox
            name="newsletterSubscription"
            label="Ik wil informatie ontvangen over programma's, evenementen en aanbiedingen van BNNVARA."
          />
          <Checkbox
            name="terms"
            validation="accepted"
            label="Ik ga akkoord met de algemene voorwaarden"
          >
            Ja, Ik ga akkoord met de{' '}
            <S.Link href={link} target="_blank" rel="noopener noreferrer">
              algemene voorwaarden van BNNVARA
            </S.Link>
            .*
          </Checkbox>

          <SubmitButton title="Doorgaan naar betalen" fullWidth />
        </BaseForm>
      </S.Wrapper>
    </Fragment>
  );
};

Form.propTypes = {
  donateMutation: PropTypes.func.isRequired,
};

export const DonationForm = () => {
  const [donate] = useMutation(Donate);

  return <Form donateMutation={donate} />;
};
